import React from 'react';
import { OptimizedImage } from '@/components/common/OptimizedImage';

interface BenefitItemProps {
  title: string;
  imageUrl?: string;
  icon?: string;
  maxLines?: number;
  className?: string;
  imageClassName?: string;
  textClassName?: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({
  title,
  imageUrl,
  icon,
  maxLines = 3,
  className = '',
  imageClassName = '',
  textClassName = '',
}) => {
  const imageSrc = imageUrl || icon || '/assets/images/No-Image.jpg';

  return (
    <div
      className={`flex flex-col items-center w-full min-w-0 overflow-hidden ${className}`}
    >
      <div
        className={`w-10 h-10 rounded-[10px] flex items-center justify-center overflow-hidden bg-white flex-shrink-0 ${imageClassName}`}
      >
        <div className='relative' style={{ width: '20px', height: '20px' }}>
          <OptimizedImage
            src={imageSrc}
            alt={title}
            fill
            style={{ objectFit: 'contain' }}
            priority
            loading='eager'
          />
        </div>
      </div>
      <span
        className={`mt-2 text-[12px] leading-[15px] text-black text-center overflow-hidden block w-full ${textClassName}`}
        style={{
          display: '-webkit-box',
          width: '100%',
          maxWidth: '100%',
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: 'vertical',
          lineHeight: '15px',
        }}
        title={title}
      >
        {title}
      </span>
    </div>
  );
};

export default BenefitItem;
